import { ActivitesModel, ActivityStudentModel, OverallToolListModel, StudentActivitiesModel } from '@/models/data-lake/data-lake';

export class DataLakeSerializer {

    static get instance() {
        return this.INSTANCE;
    }
    private static INSTANCE = new DataLakeSerializer();

    public normalizeToolData(payload: any): OverallToolListModel[] {
      const results = payload.results || [];
      return results.map((item: any) => {
          return {
            toolName: item.toolname,
            studentCount: item.student_count || item.student_code,
            activityCount: item.activity_count,
            timespent: item.timespent || 0,
          } as OverallToolListModel;
      });
    }

    public normalizeStudentData(payload: any): StudentActivitiesModel[] {
        const results = payload.results || [];
        return results.map((item: any) => {
          const toolList = this.normalizeToolList(item);
          const totalActivity = toolList.reduce((a: number, b: any) => a + b.activitiesCount, 0);
          const totalTimespent = toolList.reduce((a: number, b: any) => a + b.totalTimespent, 0);
          return {
                studentId: item.student_id,
                studentName: item.student_name,
                totalTimespent,
                totalActivity,
                toolList,
            };
        });
    }

    public normalizeToolList(payload: any) {
        const toolContent = payload.tools_list || [];
        return toolContent.map((item: any) => {
          const activities = this.normalizeActivities(item.tool_activity);
          const totalTimespent = activities.reduce(
              (a: number, b: ActivitesModel) => a + b.timespent, 0);
          return {
                toolName: item.toolname,
                toolId: item.tool_id,
                activitiesCount: activities.length,
                totalTimespent,
                activities,
            };
        });
    }

    public normalizeActivities(payload: any) {
        const activityContent = payload || [];
        return activityContent.map((item: any) => {
            return {
                activityName: item.activity_name,
                timespent: item.timespent || 0,
            };
        });
    }

    public normalizeActivityData(payload: any) {
      const results = payload.results || [];
      const activityItems: ActivityStudentModel[] = [];
      results.forEach((item: any) => {
          const toolList = this.normalizeActivityTool(item);
          toolList.forEach((toolItem: any) => {
            const activityData: ActivityStudentModel = {
                id: item.activity_id,
                activityName: item.activity_name,
                toolName: toolItem.toolName,
                studentCount: toolItem.studentCount,
                timespent: toolItem.timespent || 0,
            };
            activityItems.push(activityData);
          });
        });
      return activityItems;
    }

    public normalizeStudentsVendor(payload: any) {
        const results = payload.results || [];
        return results.map((item: any) => {
            return {
              toolName: item.toolname,
              toolId: item.tool_id,
              studentList: this.normalizeStudentList(item),
            };
        });
    }

  public normalizeCuriculumProvider(payload: any, isHighContrastEnable: any) {
    const results = payload || [];
    if (isHighContrastEnable) {
      for (const iterator of results) {
        this.getHighContrastColor(iterator);
      }
    }
    return results;
  }

    private normalizeActivityTool(payload: any) {
      const toolList = payload.tools_list || [];
      return toolList.map((item: any) => {
        return {
          toolName: item.tool_name,
          studentCount: item.student_count,
          timespent: item.timespent || 0,
        };
      });
    }

    private normalizeStudentList(payload: any) {
      const studentList = payload.student_list || [];
      return studentList.map((item: any) => {
        return {
          studentName: item.student_name,
          studentId: item.student_id,
          activityList: this.normalizeActivities(item.activity_list),
        };

      });
    }

  private getHighContrastColor(tool: any) {
    switch (tool.colorCode) {
      case '#3782c1':
        tool.colorCode = '#00458a';
        tool.textColor = '#ffffff';
        break;
      case '#c0485c':
        tool.colorCode = '#a00514';
        tool.textColor = '#ffffff';
        break;
      case '#378cdf':
        tool.colorCode = '#0051a3';
        tool.textColor = '#ffffff';
        break;
      case '#ffffff':
        if (tool.textColor === '#378cdf') {
          tool.textColor = '#00458a';
        } else if (tool.textColor === '#86c250') {
          tool.textColor = '#00793e';
        }
        break;
    }
    return tool;
  }
}

export const dataLakeSerializer = DataLakeSerializer.instance;
